const WHATSAPP_LINK = "https://wa.me/557183822916";
const BG_IMAGE =
  "https://readdy.ai/api/search-image?query=minimalist%20modern%20office%20building%20interior%20clean%20neutral%20tones%20elegant%20corridor%20marble%20floor%20soft%20natural%20light%20architectural%20abstract%20sophisticated%20serene%20contemporary%20workspace%20muted%20grey%20beige%20tones%20professional%20environment&width=1920&height=1080&seq=hero3neutral&orientation=landscape";

export default function HeroSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToEscritorio = () => {
    const el = document.querySelector("#escritorio");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={BG_IMAGE}
          alt="Fundo institucional Georges Humbert Advocacia"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-petrol-darkest/85 via-petrol-dark/80 to-petrol-darkest/90" />
      </div>

      {/* Decorative gold line */}
      <div className="absolute left-1/2 -translate-x-1/2 bottom-0 w-px h-24 bg-gradient-to-b from-gold-light/60 to-transparent" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center py-32">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-gold-light/40 text-gold-light text-xs font-medium tracking-widest uppercase px-4 py-2 rounded-full mb-10 animate-fade-in">
          <span className="w-1 h-1 rounded-full bg-gold-light inline-block" />
          Advocacia de Excelência na Bahia
          <span className="w-1 h-1 rounded-full bg-gold-light inline-block" />
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6 animate-fade-in-up">
          Advocacia estratégica com{" "}
          <span className="text-gold-light">excelência</span> e precisão jurídica.
        </h1>

        <p className="text-white/70 text-lg md:text-xl font-light leading-relaxed max-w-2xl mx-auto mb-12 animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
          Atuação profissional orientada à segurança jurídica, análise técnica e
          resultados consistentes para cada cliente.
        </p>

        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up"
          style={{ animationDelay: "0.4s" }}
        >
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 bg-gold-light hover:bg-gold-medium text-petrol-darkest font-semibold px-8 py-4 rounded-md transition-all duration-300 text-sm tracking-wide whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg" />
            </span>
            Falar com um Advogado
          </a>
        </div>

        {/* Stats row */}
        <div
          className="grid grid-cols-3 gap-6 max-w-xl mx-auto mt-20 pt-10 border-t border-white/10 animate-fade-in"
          style={{ animationDelay: "0.6s" }}
        >
          {[
            { value: "100%", label: "Comprometimento" },
            { value: "Ética", label: "Acima de tudo" },
            { value: "Bahia", label: "Referência jurídica" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-gold-light text-2xl font-bold mb-1">{stat.value}</div>
              <div className="text-white/50 text-xs tracking-wider uppercase">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToEscritorio}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/40 hover:text-gold-light transition-colors duration-300 cursor-pointer"
      >
        <span className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-2xl animate-bounce" />
        </span>
      </button>
    </section>
  );
}
